import { AlertTriangle } from 'lucide-react'
import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useViewOnly } from '@/components/templates/app-shell'
import { displayDateTime } from '@/lib/dates'
import { connectionPath, type Connection } from './types'
import { relativeConnectionTime } from './ConnectionCells'

const reasons: Record<string, string> = {
  credentials_rejected: 'Credentials rejected',
  record_errors: 'More than 10% of records errored',
  consecutive_failures: 'Three consecutive failed runs',
}
export function ConnectionAttention({
  row,
  onSync,
  pending,
}: {
  row: Connection
  onSync: () => void
  pending: boolean
}) {
  const viewOnly = useViewOnly()
  return (
    <Alert className="flex items-center justify-between gap-3">
      <span className="flex items-center gap-2">
        <AlertTriangle className="size-4 shrink-0" strokeWidth={1.5} />
        <span>
          <span className="font-medium">{row.display_name} needs attention</span> ·{' '}
          {reasons[row.needs_attention_reason ?? ''] ?? row.needs_attention_reason} · since{' '}
          {row.needs_attention_since ? (
            <time
              dateTime={row.needs_attention_since}
              title={displayDateTime(row.needs_attention_since)}
            >
              {relativeConnectionTime(row.needs_attention_since)}
            </time>
          ) : (
            '—'
          )}
        </span>
      </span>
      {!viewOnly && (
        <span className="flex shrink-0 items-center gap-2">
          <Button asChild variant="outline" size="sm">
            <a href={connectionPath(row)}>Reconnect</a>
          </Button>
          {!row.accounting_bridge && (
            <Button variant="outline" size="sm" onClick={onSync} disabled={pending}>
              Sync now
            </Button>
          )}
        </span>
      )}
    </Alert>
  )
}
